import styled from "styled-components";

export const EmployeeInfoContainer = styled.div`
  width: 100%;
  max-width: 400px;
  background: ${({theme}) => theme.white};
  border: 1px solid ${({theme}) => theme.grayDivider};
  border-radius: 8px;
  padding: 32px;
  margin-right: 15px;
  word-wrap: break-word;
  @media (max-width: ${({theme}) => theme.breakpoints.lg}) {
    max-width: unset;
    margin-bottom: 30px;
    margin-right: 0;
  }
`;

export const EmployeeAvatar = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-right: 24px;
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    display: none;
  }
`

export const EmployeeInfoHeader = styled.div`
  align-items: start;
  display: flex;
  margin-bottom: 34px;
  justify-content: space-between;

  button {
    margin-top: 5px;
  }
`;

export const EmployeeInfoBody = styled.div`

`
export const EmployeeSalary = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  
  p {
    font-size: 30px;
    font-weight: 700;
    line-height: 36px;
    letter-spacing: 0.3px;
    text-align: left;
    color: ${({theme}) => theme.accent};
  }

  button {
    all: unset;
    cursor: pointer;
  }
  
  .icon_wrapper{
    margin-left: 10px;
    width: 20px;
    height: 20px;
    
    svg {
      path{
        fill: ${({theme}) => theme.gray}
      }
    }
  }
  
`

export const EmployeeData = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.2px;
  text-align: left;
  color: ${({theme}) => theme.grayDark};
  margin-bottom: 25px;

  label {
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0.1px;
    text-align: left;
    color: ${({theme}) => theme.gray} !important;
    margin-bottom: 4px;
  }
`

export const HeaderInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;

  *:nth-child(2) {
    margin: 5px 0;
  }
`

export const HeaderAddress = styled.div`
  display: flex;
  align-items: baseline;
  
  p{
    margin-top: 0 !important;
  }

  *:not(:last-child) {
    margin-right: 8px;
  }
`
export const JobDescriptionContainer = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  letter-spacing: 0.2px;
  text-align: left;
  color: ${({theme}) => theme.grayDark};
  margin-bottom: 25px;
  > label {
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0.1px;
    text-align: left;
    color: ${({theme}) => theme.gray} !important;
    margin-bottom: 4px;
  }
  > div {
    display: flex;
    align-items: center;
    overflow: hidden;
    > p {
      margin: 0;
      flex-grow: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    > button {
      all: unset;
      &:hover {
        cursor: pointer;
      }
    } 
  }
`;

export const ModalJobDescriptionContainer = styled.div`
  background: ${({theme}) => theme.white};
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.16);
  border-radius: 12px;
  max-width: 560px;
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    min-width: unset;
    width: 100%;
  }
`

export const ModalJobDescriptionContent = styled.div`
  padding: 42px 52px;
  
  > h1{
    font-style: normal;
    font-weight: 700;
    font-size: 19px;
    line-height: 23px;
    text-align: left;
    letter-spacing: 0.4px;
    color:  ${({theme}) => theme.black};
    margin-bottom: 24px;
  }
  > p{
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    letter-spacing: 0.3px;
    color: ${({theme}) => theme.grayDark};
    margin-bottom: 24px;
  }
`
